/* eslint-disable import/prefer-default-export */
import React from 'react';
import { Typography, styled } from '@mui/material';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { CellTypes } from '../../services/vehicles';

const LinkText = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  cursor: 'pointer',
  fontSize: '0.7rem',
}));

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));

const LinkCell = ({ value }: any) => <LinkText> {value || '--'} </LinkText>;
const PlainCell = ({ value, ...rest }: any) => (
  <LightTooltip title={value}>
    <Typography variant="caption"> {value || '--'} </Typography>
  </LightTooltip>
);

export const cellTypes = {
  Link: LinkCell,
  Tag: CellTypes.Tag,
  Date: CellTypes.Date,
  CurrencyDropDown: CellTypes.CurrencyDropDown,
  Country: CellTypes.Country,
  ProgressBar: CellTypes.ProgressBar,
  Plain: PlainCell,
};
